<!--  -->
<template>
  <div>
    <div style="padding:80px 40px">
      <el-table
        v-loading="loading"
        :data="tableData"
        style="width:100%;"
        border
        max-height="500"
      >
        <el-table-column
          align="center"
          label="企业ID"
          prop="corp_id"
          width="180"
        >
          <template slot-scope="scope">
            <!-- <span v-if="!scope.row.isModify">{{ scope.row.corp_id }}</span> -->
            <el-popover
              v-if="!scope.row.isModify"
              placement="top-start"
              title="企业ID"
              width="200"
              trigger="hover"
              :content="scope.row.corp_id"
            >
              <p slot="reference">{{ scope.row.corp_id }}</p>
            </el-popover>
            <el-input v-else v-model="scope.row.textCorpId" />
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="企业名称"
          prop="corp_name"
          width="280"
        >
          <template slot-scope="scope">
            <span v-if="!scope.row.isModify">{{ scope.row.corp_name }}</span>
            <el-input v-else v-model="scope.row.textCorpName" />
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="企业头像"
          prop="corp_name"
          width="300"
        >
          <template slot-scope="scope">
            <el-image
              :src="scope.row.corp_square_logo_url"
              fit="fill"
            />
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          label="授权应用"
          prop="agent_agent_name"
          width="100"
        />
        <el-table-column
          align="center"
          label="应用头像"
          prop="agent_square_logo_url"
        >
          <template slot-scope="scope">
            <el-image
              :src="scope.row.agent_square_logo_url"
              fit="contain"
            />
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="客服开关"
          prop="secret"
        >
          <template slot-scope="scope">
            <div style="position: relative; display: inline-block;">
              <el-switch
                v-model="scope.row.kf_status"
                :width="60"
                active-color="#13ce66"
                inactive-color="rgb(191,191,191)"
                :active-value="1"
                :inactive-value="9"
                @change="statusChange(scope.row)"
              />
              <div
                v-if="scope.row.kf_status === 1"
                style="color: #fff;position: absolute;top: 2px;left: 7px;"
              >启用</div>
              <div
                v-else
                style="color: #fff;position: absolute;top: 2px;right: 7px;"
              >禁用</div>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column
          :key="mathRandom"
          label="操作"
          width="150"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click.native.prevent="updateDepartment(scope.row.id)"
            >
              更新部门
            </el-button>
          </template>
        </el-table-column> -->
      </el-table>
    </div>
    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import { getMicroEnterprise, newEnterpriseAndMicro, delteMicro, wechatcomupdataaccountr, updateDepartment } from '@/api/providerAccountManagement/servicePorviderList2.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      form: {
        corp_name: '',
        corp_id: ''
        // secret: '',
        // token: '',
        // aes_key: '',
        // video_account: '',
        // customer_contact_secret: ''
      },
      stutes: null,
      pwdFlag: true, // 密码标示 true表示当前是密码形式
      account_name: '',
      login_pwd: '',
      pay_pwd: '',
      mathRandom: null,
      tableData: [],
      loading: false,
      query: {
        page: 1,
        pageSize: 10,
        company_name: null
      },
      total: null,

      company_name: '',
      ster: null
    }
  },
  created() {
    this.accountlist()
  },
  mounted() {

  },
  methods: {
    async accountlist() {
      this.loading = true
      const data = await getMicroEnterprise(this.query)
      for (let i = 0; i < data.data.list.length; i++) {
        data.data.list[i].textCorpId = data.data.list[i].corp_id
        data.data.list[i].textCorpName = data.data.list[i].corp_name
        data.data.list[i].textSecret = data.data.list[i].secret
        data.data.list[i].textToken = data.data.list[i].token
        data.data.list[i].textAeskey = data.data.list[i].aes_key
        data.data.list[i].textvideoAccount = data.data.list[i].video_account
        data.data.list[i].customercontactSecret = data.data.list[i].customer_contact_secret

        data.data.list[i].isModify = false
      }
      this.loading = false
      this.tableData = data.data.list
      this.total = data.data.total
    },
    async addcread() {
      if (this.form.corp_name === '') {
        this.$message.error('请填写企业名称')
        return
      }
      if (this.form.corp_id === '') {
        this.$message.error('请填写企业ID')
        return
      }
      // if (this.form.secret === '') {
      //   this.$message.error('请填写客服密钥')
      //   return
      // }
      // if (this.form.token === '') {
      //   this.$message.error('请填写客服token')
      //   return
      // }
      // if (this.form.aes_key === '') {
      //   this.$message.error('请填写客服aeskey')
      //   return
      // }
      // if (this.form.video_account === '') {
      //   this.$message.error('请填写视频号')
      //   return
      // }
      // if (this.form.customer_contact_secret === '') {
      //   this.$message.error('请填写客户联系secret')
      //   return
      // }

      await newEnterpriseAndMicro(this.form)
      this.accountlist()
      this.rest()
      this.$message({
        message: '添加成功',
        type: 'success'
      })
    },

    rest() {
      this.form.corp_name = ''
      this.form.corp_id = ''
      this.form.secret = ''
      this.form.token = ''
      this.form.aes_key = ''
      this.form.video_account = ''
      this.form.customer_contact_secret = ''
    },

    // 确定修改
    async confirmAccount(item) {
      // const id = item.id
      console.log('56555', item)
      if (item.textvideoAccount === '') {
        this.$message.error('请填写视频号')
        return
      }
      const data = await wechatcomupdataaccountr({
        id: item.id,
        corp_id: item.textCorpId,
        corp_name: item.textCorpName,
        secret: item.textSecret,
        token: item.textToken,
        aes_key: item.textAeskey,
        video_account: item.textvideoAccount,
        customer_contact_secret: item.customercontactSecret
      })
      this.accountlist()
      this.$message({
        message: '修改成功',
        type: 'success'
      })
      console.log(data)
    },

    // 删除
    async deleteAccount(id) {
      await delteMicro(id)
      this.$message({
        message: '删除成功',
        type: 'success'
      })
      this.accountlist()
    },

    async updateDepartment(id) {
      await updateDepartment({ corp_id: id })
      await this.accountlist()
      this.$message({
        message: '更新成功',
        type: 'success'
      })
    },

    // 分页
    fetchPageSize(e) {
      this.query.pageSize = e
      this.accountlist()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.accountlist()
    },
    resback() {
      this.rest()
    },
    async statusChange(item) {
      console.log('item', item.kf_status)
      const data = await wechatcomupdataaccountr({
        id: item.id,
        kf_status: item.kf_status === 1 ? 1 : 9
      })
      this.accountlist()
      this.$message({
        message: '操作成功',
        type: 'success'
      })
      console.log(data)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.form_box{
  /* margin-top: 30px; */
  padding: 10px 10px 0px 10px;
}
 ::v-deep .el-switch__core{
    width: 70px !important;
}
.titip{
    width: 126px;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1; /* 这里是超出几行省略 */
    overflow: hidden;
}
</style>
